import { Pipe, PipeTransform } from '@angular/core';
import { TriggerTypeEnum } from '@app/_shared/modules/strategy-form/strategy.enums';
import { TriggerType } from '../../../../utProto/webApiStrategyEnums_pb';

@Pipe({
  name: 'triggerType'
})
export class TriggerTypePipe implements PipeTransform {

  transform(value: number): unknown {
    if (value === TriggerType.TRIGGERTYPE_STOP_LOSS_RANGE_EXIT || value === TriggerType.TRIGGERTYPE_TARGET_PROFIT_RANGE_EXIT) {
      return TriggerTypeEnum[TriggerType.TRIGGERTYPE_TARGET_PROFIT_RANGE_EXIT];
    } else if (value === TriggerType.TRIGGERTYPE_LOCKED_PROFIT_EXIT) {
      return TriggerTypeEnum[TriggerType.TRIGGERTYPE_LOCKED_PROFIT_EXIT];
    }
    return TriggerTypeEnum[value];
  }

}
